import { env } from '@/shared/config';

const STAGING_MARKERS = ['staging', '-stg'];

function isStagingHost(host: string) {
  return STAGING_MARKERS.some((marker) => host.includes(marker));
}

function normalizeCookieDomain(host: string) {
  return host.replace(/^www\./, '');
}

const isStaging = [env.siteHost, env.playgroundHost, env.forumHost].some(isStagingHost);

export const loginStateCookieConfig = {
  cookieName: `login-state${isStaging ? '-stg' : ''}`,
  domain: env.isProd ? normalizeCookieDomain(env.siteHost) : 'localhost',
  path: '/',
  secure: env.isProd,
  maxAgeDays: 365,
} as const;

export const loggedInTimestampCookieConfig = {
  cookieName: 'loggedInTimestamp',
  domain: loginStateCookieConfig.domain,
  path: loginStateCookieConfig.path,
  secure: loginStateCookieConfig.secure,
  maxAgeDays: loginStateCookieConfig.maxAgeDays,
} as const;

export const cookieWatchConfig = {
  pollIntervalMs: 1000,
} as const;
